// extracted by mini-css-extract-plugin
module.exports = {"container":"_2kG6h5fgRLcgmz-EM6XVmx"};